import React, { useState, useEffect } from 'react';
import { useAuth } from './authContext';

const InactivityWarningModal = () => {
  const { showInactivityWarning, logout } = useAuth();
  const [countdown, setCountdown] = useState(300); // 5 minutes in seconds

  useEffect(() => {
    if (showInactivityWarning) {
      setCountdown(300); // Reset countdown to 5 minutes
      
      const interval = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            logout(); // Auto logout when countdown reaches 0
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [showInactivityWarning, logout]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  if (!showInactivityWarning) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4 font-ui">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
        {/* Header */}
        <div className="flex items-center mb-4">
          <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mr-4">
            <svg className="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-800">Session Expiring Soon</h3>
            <p className="text-sm text-gray-600">Your session will expire due to inactivity</p>
          </div>
        </div>

        {/* Countdown */}
        <div className="text-center mb-6">
          <div className="text-3xl font-bold text-red-600 mb-2">
            {formatTime(countdown)}
          </div>
          <p className="text-sm text-gray-600">
            Move your mouse anywhere on the page to extend the session.
          </p>
        </div>  
      </div>
    </div>
  );
};

export default InactivityWarningModal;
